import { LICENSING_SELECTION_CHANGE, log } from "./LicensingSelector";
import { safeParseInt, OptionSelector } from "./OptionSelector";

/** The row corresponding to one medium row, e.g. Desktop. */

export class MediumRow {
  /** @type {number} */
  id;
  /** @type {string} */
  slug;
  /** @type {boolean} */
  isSelected;
  /** @type {{[id: number]: OptionSelector}} */
  optionGroups;

  /** @type {HTMLInputElement} */
  checkboxElement;

  static fromElement(element) {
    return new MediumRow(element);
  }

  constructor(element) {
    this.element = element;
    this.id = safeParseInt(element.dataset.licensingMediumId);
    this.slug = element.dataset.licensingMediumSlug;

    this.log = log.extend(`MediumRow:${this.slug}`);
    this.log("Creating MediumRow", element);

    this.checkboxElement = element.querySelector("input[type='checkbox']");
    this.optionGroups = Array.from(
      element.querySelectorAll(
        ".licensing-option-group:not(.licensing-option-group--license-usage)"
      )
    ).map(OptionSelector.fromElement);
    this.isSelected = this.checkboxElement.checked;

    this._handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.checkboxElement.addEventListener("change", this._handleCheckboxChange);

    this.syncSelectedRowHighlight();
  }

  /** Toggles `.selected` on the row so checked mediums are highlighted. */
  syncSelectedRowHighlight() {
    if (!this.checkboxElement) return;
    this.element.classList.toggle("selected", this.checkboxElement.checked);
  }

  handleCheckboxChange() {
    this.log("handleCheckboxChange", this.checkboxElement.checked);
    this.isSelected = this.checkboxElement.checked;
    this.syncSelectedRowHighlight();
    this.element.dispatchEvent(
      new CustomEvent(LICENSING_SELECTION_CHANGE, { bubbles: true })
    );
  }

  disconnect() {
    this.optionGroups.forEach((group) => group.disconnect());
    this.checkboxElement.removeEventListener(
      "change",
      this._handleCheckboxChange
    );
  }

  get selectedOptionIds() {
    return this.optionGroups.map((group) => group.selectedOptionId);
  }
}
